// extracted by mini-css-extract-plugin
export default {"node-minimal":"lsf-node-minimal","node-minimal__counter":"lsf-node-minimal__counter","node-minimal__icon":"lsf-node-minimal__icon"};
    if(module.hot) {
      // 1637785522132
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  